import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { AffectedStaffInput } from '../../../lib/types/models/affectedStaff/affected-staff-input'
import ControlledSwitch from '../../elements/controlled-switch'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import { AffectStaffRadFormFields } from './affected-staff-rad-form-fields'

type Props = {
  mode: 'create' | 'view'
}

const AffectedStaffRad = ({ mode }: Props) => {
  const form = useFormContext<AffectedStaffInput>()

  return (
    <InnerBox className="rounded-lg">
      <div className="flex justify-between items-center w-full">
        <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
          Réunion avant départ
        </Typography>

        <FormField
          control={form.control}
          name={'participatedInRad'}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ControlledSwitch
                  {...field}
                  reverseCheckedValue
                  switchVariant="primary"
                  label="Ne participe pas à la RAD ?"
                  withBorder
                  borderClassName="border-grey-light p-1"
                  variant={'label-semibold'}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
      <div className="h-3" />
      <AffectStaffRadFormFields mode={mode} radPlaceholder="Réunion avant départ" />
    </InnerBox>
  )
}

export default AffectedStaffRad
